var map = {
	"./discoverArrow.svg": 97,
	"./files.svg": 197,
	"./firmware.svg": 101,
	"./homelok.svg": 198,
	"./icon-minus.svg": 99,
	"./icon-plus.svg": 98,
	"./ks.svg": 199,
	"./locks.svg": 104,
	"./logout.svg": 200,
	"./nebula.svg": 103,
	"./peripherals.svg": 105,
	"./return.svg": 96,
	"./saltoLogo.svg": 57,
	"./software.svg": 100,
	"./space.svg": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;